// extracted by mini-css-extract-plugin
export var defaultWrapper = "_n8-3";
export var downloadButton = "_n8-4";
export var fileContainer = "_n8-9 _n8-7";
export var fileContainerBase = "_n8-7";
export var fileContainerFixedHeight = "_n8-8 _n8-7";
export var fileInfo = "_n8-5";
export var fileInfoWidthRestricted = "_n8-6";
export var fileType = "_n8-1";
export var fileTypeName = "_n8-2";
export var image = "_n8-0";
export var link = "_n8-b";
export var overflowEllipsis = "_n8-a";